import React from 'react';

/** icon-message-l */
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
        <path
            d="M3.006 1.281c-.741.109-1.383.655-1.655 1.406l-.091.253v14.12l.092.255a2.18 2.18 0 0 0 1.335 1.331c.234.082.341.09 1.401.106l1.149.016.011 1.706c.011 1.579.018 1.717.088 1.858a.773.773 0 0 0 .493.39c.349.08.29.118 3.097-1.987l2.631-1.973 4.751-.011 4.752-.011.255-.092a2.192 2.192 0 0 0 1.334-1.335l.091-.253V2.94l-.091-.253a2.192 2.192 0 0 0-1.334-1.335l-.255-.092-8.92-.005c-4.906-.003-9.016.008-9.134.026m18.063 1.65.151.15v13.838l-.151.15-.15.151-4.89.02c-4.463.018-4.899.026-5.009.087-.066.036-1.047.762-2.18 1.612l-2.06 1.546-.02-1.332c-.018-1.203-.027-1.348-.096-1.485a.87.87 0 0 0-.404-.371c-.044-.02-.777-.045-1.629-.056l-1.55-.021-.15-.151-.151-.15-.01-6.905-.011-6.904.176-.175.175-.176 8.904.011 8.905.01.15.151"
            fillRule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
